'use client';

import {
  Typography,
  type TypographyProps,
} from '@jouzen/ecom-components/v3/Typography';

const DEFAULT_PROPS: Partial<TypographyProps> = {
  color: 'gray',
};

export const Note = ({ children, ...rest }: Partial<TypographyProps>) => {
  const props = { ...DEFAULT_PROPS, ...rest };
  return <Typography {...props}>{children}</Typography>;
};

export default Note;
